const HisHandshakeHeart = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  return (
    <svg
      style={sx}
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.0272 6.15388C27.3543 5.4786 26.5547 4.94281 25.6742 4.57722C24.7938 4.21163 23.8498 4.02344 22.8965 4.02344C21.9431 4.02344 20.9992 4.21163 20.1187 4.57722C19.2383 4.94281 18.4387 5.4786 17.7657 6.15388L16.7329 7.20015L15.7 6.15388C15.0271 5.4786 14.2275 4.94281 13.347 4.57722C12.4666 4.21163 11.5226 4.02344 10.5693 4.02344C9.61596 4.02344 8.672 4.21163 7.79156 4.57722C6.91111 4.94281 6.11149 5.4786 5.43855 6.15388C2.59485 8.99758 2.42047 13.7997 6.00193 17.4482L16.7329 28.1792L27.4638 17.4482C31.0453 13.7997 30.8709 8.99758 28.0272 6.15388Z"
        stroke={strokeColor}
        strokeWidth="2.68274"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7332 7.19922L12.5347 11.4111C12.0039 11.9462 11.7061 12.6694 11.7061 13.4232C11.7061 14.1769 12.0039 14.9001 12.5347 15.4352C13.0698 15.966 13.793 16.2639 14.5467 16.2639C15.3005 16.2639 16.0237 15.966 16.5588 15.4352L19.5903 12.4708C20.3437 11.7254 21.3607 11.3073 22.4206 11.3073C23.4804 11.3073 24.4975 11.7254 25.2509 12.4708L28.4702 15.6901"
        stroke={strokeColor}
        strokeWidth="2.68274"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.7814 20.132L22.0986 17.4492"
        stroke={strokeColor}
        strokeWidth="2.68274"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.757 24.1554L18.0742 21.4727"
        stroke={strokeColor}
        strokeWidth="2.68274"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisHandshakeHeart;
